exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n.jp-OutputArea-child {\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\n.jp-RenderedText pre {\n    padding-left: 1em;\n    padding-top: 0.8em;\n    padding-bottom: 0.8em;\n}\n", ""]);

// exports
